import { Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ICONS } from '@core/services/icons/icons.service';

import { FormBuilderBase } from '@shared/components/row-edition-form/form-builder/form-builder.model';

@Component({
  selector: 'app-text-list-input',
  imports: [FormsModule],
  templateUrl: './text-list-input.component.html',
  styles: `
    :host {
      display: flex;
      width: 100%;
    }
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextListInputComponent),
      multi: true
    }
  ]
})
export class TextListInputComponent implements ControlValueAccessor {
  protected readonly ICONS = ICONS;

  id = input<FormBuilderBase['id']>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value = input<any>();

  protected values = signal<string[]>([]);
  protected inputText = signal('');
  protected isDisabled = signal(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private onChange: (_value: any) => void = () => {};
  private onTouched: () => void = () => {};

  onInputKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.appendCurrent();
    }
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.inputText.set(input.value);
  }

  removeItem(item: string): void {
    this.values.set(this.values().filter((v) => v !== item));
    this.notifyChanges();
    this.onTouched();
  }

  private appendCurrent(): void {
    const trimmed = this.inputText().trim();
    if (!trimmed) {
      return;
    }
    this.values.set([...this.values(), trimmed]);
    this.inputText.set('');
    this.notifyChanges();
    this.onTouched();
  }

  private notifyChanges(): void {
    const current = this.values();
    this.onChange(current.length > 0 ? current : null);
  }

  writeValue(value: string[] | null): void {
    this.values.set(Array.isArray(value) ? value : []);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }
}
